// extracted by mini-css-extract-plugin
export var cardTitle = "_jt-1";
export var commentBubble = "_jt-e";
export var commentForm = "_jt-a";
export var commentInput = "_jt-b";
export var commentLabel = "_jt-d";
export var commentPrompt = "_jt-9";
export var csatCard = "_jt-0";
export var feedbackSection = "_jt-7";
export var starDisabled = "_jt-6";
export var starEmpty = "_jt-5";
export var starFilled = "_jt-4";
export var starWrapper = "_jt-3";
export var starsContainer = "_jt-2";
export var submittedComment = "_jt-c";
export var thankYouText = "_jt-8";